import React from 'react';
import SectionTabs from '../SectionTabs';
import LeadersSection from './LeadersSection';
import SpacesSection from './SpacesSection';
import ScheduleSection from './ScheduleSection';
import SupervisorsSection from './SupervisorsSection';
import AssignmentsSection from './AssignmentsSection';

// Workshop pages, in tab order — add new ones here (and a render line
// below). Also drives the breadcrumb label and sidebar search (see
// AdminDashboard.js).
export const WORKSHOP_SUBSECTIONS = [
  { id: 'leaders', label: 'Workshop Leaders', description: 'Leaders, their workshops, bios and photos, pay — plus emails, contracts and each leader’s private info link' },
  { id: 'spaces', label: 'Spaces', description: 'Rooms with their maximum dancers and equipment, and what each needs set up' },
  { id: 'schedule', label: 'Schedule', description: 'Drag workshops into Session 1 and Session 2 — with rule checks and auto-suggest' },
  { id: 'supervisors', label: 'Supervisors', description: 'Teacher/chaperone supervisors for every workshop, in both sessions' },
  { id: 'assignments', label: 'Dancer Assignments', description: 'Release the schedule to teachers, school spots, who’s in each workshop, and rosters' },
];

// activeSection is the shared sub-page state (AdminDashboard's regSection).
export default function WorkshopsSection({ activeSection, setActiveSection }) {
  return (
    <SectionTabs sectionKey="workshops" tabs={WORKSHOP_SUBSECTIONS} activeSection={activeSection} setActiveSection={setActiveSection}>
      {(id) => (
        <>
          {id === 'leaders' && <LeadersSection />}
          {id === 'spaces' && <SpacesSection />}
          {id === 'schedule' && <ScheduleSection />}
          {id === 'supervisors' && <SupervisorsSection />}
          {id === 'assignments' && <AssignmentsSection />}
        </>
      )}
    </SectionTabs>
  );
}
